import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool, utils_tool} from '../../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';
import {Descriptions} from 'antd';
import moment from "moment";

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool
let {WizBrowserExport, WizModal, WizCard} = component_tool
let {Session} = utils_tool

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const _getValue = (type, key) => {
  const values = {
    partType: {
      0: '课程',
      1: '考试',
      2: '投票',
      3: '系列化课程',
      4: '图片',
      5: '链接',
      6: '视频',
    },
  }
  return values[type][key]
}
class ActivityPartManager extends WizContainer {
  componentName = 'activityPartManager'

  constructor(props) {
    super(props)
    const {history} = props
    let activityInfo = {};
    if (history.location && history.location.pathname === '/interact/activity/activityDetailToPart') {
      if (history.location && history.location.record) {
        activityInfo = history.location.record
        Session.set('activityInfo', activityInfo)
      } else {
        activityInfo = Session.get('activityInfo') || {}
      }
    }
    this.activityInfo = activityInfo
    this.filters = {}
    this.state = {
      activityId: activityInfo.id || activityInfo.activityId
    }
  }

  _componentDidMount() {
    if (this.state && this.state.activityId) {
      this.doAction({
        path: 'activity/look',
        payload: {
          key: 'activityInfo',
          apiParams: {id: this.state.activityId}
        }
      })
    }
    this._getActivityPartList();
  }

  _getActivityPartList(apiParams = {}) {
    let {activityId} = this.state
    this.doAction({
      path: 'activityPart/listByPage',
      payload: {
        key: 'activityPart@listByPage',
        apiParams: {
          activityId: activityId,
          ...apiParams
        }
      }
    })
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '环节类型',
        field: 'type',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '环节名称',
        field: 'title',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '环节状态',
        field: 'active',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '环节时间',
        field: 'partTime',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '参与人数',
        field: 'participateNum',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['active'] == 0 ? e['active'] = "关闭" : e['active'] = "打开"
        e['type'] = _getValue('partType',e['type'])
        e['partTime'] = e['startTime'] + ' ~ ' + e['endTime']
      })
      WizBrowserExport({
        title: '活动环节信息',
        sheetName: '活动环节信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '活动环节信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleParticipateFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '学员姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '学员账户',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '用户类型',
        field: 'userType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '参加活动时间',
        field: 'participateTime',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      let activityPart = data['activityPart']
      let participateInfos = data['participateInfos']
      let type = activityPart['type']
      switch (type) {
        case 0: activityPart['typeName'] = '课程'; break;
        case 1: activityPart['typeName'] = '考试'; break;
        case 2: activityPart['typeName'] = '投票'; break;
        case 3: activityPart['typeName'] = '系列化课程'; break;
        case 4: activityPart['typeName'] = '图片'; break;
        case 5: activityPart['typeName'] = '链接'; break;
        case 6: activityPart['typeName'] = '视频'; break;
      }
      let str = '活动名称：'+ activityPart['activityName'] + '\n'
        + '环节名称：' + activityPart['title'] + '\n'
        + '环节类型：' + activityPart['typeName'] + '\n'
        + '环节时间：' + activityPart['startTime'] + ' ~ ' + activityPart['endTime']

      participateInfos.forEach(e => {
        e['userType'] == 0 ? e['userType'] = '学员' : e['userType'] == 1 ? e['userType'] = 'SGM总部' : e['userType'] == 2 ? 'SGM区域' : e['userType'] = '供应商'
      })
      WizBrowserExport({
        title: str,
        sheetName: '活动环节参加记录',
        columns: columnDefs.filter((_, index) => index),
        rows: participateInfos,
        filename: '活动环节参加记录.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 50
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({activityId: this.state.activityId}),
      apiDataFormat: {
        add: this._handleCMD,
        export: this._handleFile,
        enable: this._handleCMD,
        participateExport: this._handleParticipateFile,
      },
      activityId: this.state.activityId
    })
    let {activityInfo} = this.props
    if(activityInfo && activityInfo.success) {
      this.activityInfo = activityInfo.data
    }
    const items = this.activityInfo
    let applyName = ''
    if (items['apply'] === 0) {
      applyName = '否'
    } else {
      applyName = '是'
    }
    return (
      <React.Fragment>
        <WizCard title={'活动信息'}>
          <Descriptions column={2} style={{paddingLeft: 25}}>
            <Descriptions.Item label='活动名称'>{items.name}</Descriptions.Item>
            <Descriptions.Item label='活动时间'>{formatterDate(items.startTime)} ~ {formatterDate(items.endTime)}</Descriptions.Item>
            <Descriptions.Item label='主办方'>{items.sponsor}</Descriptions.Item>
            {/*<Descriptions.Item label='是否需要报名'>{applyName}</Descriptions.Item>*/}
          </Descriptions>
        </WizCard>

        <WizCard title={'活动环节'}>
          <WizReduxTemplate {..._reduxTemplateConfig}/>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let {activity, activityPart} = state
  const activityInfo = modelUtils.getModelEntity(activity, 'activityInfo');
  const partList = modelUtils.getModelEntity(activityPart, 'activityPart@listByPage')
  const load = modelUtils.getLoadingState(state, 'activityPart')
  return {
    activityInfo,
    partList,
    ...load
  }
};

export default connect(mapStateToProps)(ActivityPartManager);
